<template>
    <div>
        <div class="second-header-wrap">
            <el-button @click="$router.back()" size="medium">返回</el-button>
            <el-button type="primary" v-if="status === 1" @click.native="saveHandler(1)" size="medium">保存</el-button>
            <el-button type="primary" @click.native="saveHandler(2)" size="medium">发布</el-button>
        </div>
        <div class="main-container">
            <el-form
                :model="formData"
                label-width="150px"
                :rules="rules"
                ref="form"
            >
                <el-form-item label="主题" prop="title">
                    <div style="width: 500px;">
                        <el-input v-model   ="formData.title" maxlength="100" placeholder="主题（1-100字）"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="报名时间" prop="dateRange">
                    <el-date-picker
                        v-model="formData.dateRange"
                        type="datetimerange"
                        format="yyyy-MM-dd HH:mm"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="出生日期限制" prop="ageRange">
                    <el-date-picker
                        v-model="formData.ageRange"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="招生人数">
                    <el-input-number :precision="0" v-model="formData.maxRecruitCount" :min="0"
                                     :max="1000000"></el-input-number>
                </el-form-item>
                <el-form-item v-show="false" label="封面" prop="cover">
                    <el-upload
                        class="logo-uploader"
                        :action="`${ basePath }common/addImageUp`"
                        :show-file-list="false"
                        :before-upload="beforeUploadHandler"
                        :on-success="coverUploadSuccessHandler"
                    >
                        <div v-if="formData.cover !== ''"
                             class="logo-image"
                             :style="{backgroundImage: `url(${formData.cover})`}"></div>
                        <div v-else class="upload-hint">+</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="招生简章" prop="recruitDesc">
                    <ueditor class="rich-editor" ref="ueditor" :defaultMes="formData.recruitDesc"
                             @editModel="richTextEditHandler"></ueditor>
                </el-form-item>
                <el-form-item label="报名模板" prop="voteId">
                    <el-select v-if="status !== 2" v-model="formData.voteId" placeholder="请选择">
                        <el-option
                            v-for="templateItem in templateList"
                            :key="templateItem.id"
                            :label="templateItem.voteTitle"
                            :value="templateItem.id">
                        </el-option>
                    </el-select>
                    <div v-else>{{getTemplateName(formData.voteId)}}</div>
                </el-form-item>

            </el-form>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin';
    import {getVoteTwoTempList} from '@/api/setting';

    import {
        updateVoteTwoRecruitNotice,
        getVoteTwoRecruitNotice,
        sendViewVoteTwo
    } from '@/api/notice';
    import moment from 'moment';
    import Ueditor from '@/components/Ueditor';

    export default {
        name: "NoticeEdit",
        data() {
            const datetimeValidator =(rule, value, callback) => {
                if(this.formData.dateRange[0] && this.formData.dateRange[1]) {
                    if(moment(this.formData.dateRange[0]).format('YYYY-MM-DD HH:mm') >= moment(this.formData.dateRange[1]).format('YYYY-MM-DD HH:mm')) {
                        callback(new Error('报名结束时间必须大于开始时间'));
                    } else {
                        callback()
                    }
                } else {
                    callback(new Error('报名时间不能为空'))
                }
            };
            return {
                id: this.$route.query.id,
                formData: {
                    title: '',
                    dateRange: [],
                    cover: '',
                    recruitDesc: '',
                    voteId: null,
                    ageRange: [],
                    maxRecruitCount: 1,
                },
                status: 1,
                rules: {
                    title: [{
                        required: true, message: '主题不能为空', trigger: 'blur'
                    }],
                    dateRange: [{
                        required: true, validator: datetimeValidator, trigger: 'blur'
                    }],
                    cover: [{
                        required: true, message: '封面不能为空', trigger: 'blur'
                    }],
                    recruitDesc: [{
                        required: true, message: '招生简章不能为空', trigger: 'blur'
                    }],
                    voteId:  [{
                        required: true, message: '报名模板不能为空', trigger: 'blur'
                    }]
                },
                templateList: []
            }
        },
        mixins: [baseMixin],
        components: {
            Ueditor,
        },
        created() {
            getVoteTwoRecruitNotice({
                noticeId: this.id
            })
                .then(res => res.data)
                .then(data => {
                    if(data.result) {
                        const pageData = data.data;
                        this.$refs.ueditor.setContent(data.data.recruitDesc);
                        this.formData = {
                            title: pageData.title,
                            recruitDesc: pageData.recruitDesc,
                            dateRange: [pageData.startDate, pageData.endDate],
                            voteId: pageData.voteId,
                            cover: pageData.cover,
                            maxRecruitCount: pageData.maxRecruitCount,
                            ageRange: [pageData.minBirthday, pageData.maxBirthday]
                        };
                        this.status = pageData.status;
                    }
                });
            getVoteTwoTempList({
                voteTitle: ''
            })
                .then(res => res.data)
                .then(data => {
                    this.templateList = data.data.filter(({voteStatus}) => voteStatus === 2);
                })
        },
        methods: {
            getTemplateName(voteId) {
                let name = '';
                if(this.templateList.length !== 0) {
                    name = this.templateList.find(({id}) => id === this.formData.voteId).voteTitle;
                }
                return name;
            },
            saveHandler(status) {
                this.formData.recruitDesc = this.$refs.ueditor.getContent();
                const args = {};

                args.id = this.id;
                args.cover = this.formData.cover;
                args.recruitDesc = this.formData.recruitDesc;
                args.status = status;
                args.title = this.formData.title;
                args.voteId = this.formData.voteId;
                args.startDate = `${moment(this.formData.dateRange[0]).format('YYYY-MM-DD HH:mm')}:00`;
                args.endDate = `${moment(this.formData.dateRange[1]).format('YYYY-MM-DD HH:mm')}:00`;
                args.minBirthday = moment(this.formData.ageRange[0]).format('YYYY-MM-DD');
                args.maxBirthday = moment(this.formData.ageRange[1]).format('YYYY-MM-DD');
                args.maxRecruitCount = this.formData.maxRecruitCount;
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        args.recruitDesc = this.$refs.ueditor.getContent();

                        this.$confirm(`是否确认${status === 1 ? '保存' : '发布'}?`, `${status === 1 ? '保存' : '发布'}`, {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            updateVoteTwoRecruitNotice(args)
                                .then(res => res.data)
                                .then(data => {
                                    if(data.result) {
                                        this.$message({
                                            message: status === 1 ? '保存公告成功' : '发布公告成功',
                                            type: 'success'
                                        });
                                        this.$router.back();
                                    } else {
                                        this.$message.error(data.msg);
                                    }
                                });
                        }).catch(() => {
                        });


                    }
                });
            },
            beforeUploadHandler(file) {
                const ext = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
                const extList = ['jpg', 'png', 'gif', 'bmp', 'jpeg'];
                if(extList.indexOf(ext) === -1) {
                    this.$message({
                        message: `封面后缀名必须是[${extList.join(', ')}]`,
                        type: 'error'
                    });
                    return false;
                }
            },
            richTextEditHandler(recruitDesc) {
                this.formData.recruitDesc = recruitDesc;
                this.$refs.form.validateField('recruitDesc');
            },
            coverUploadSuccessHandler(res) {
                this.formData.cover = res.data.url;
                this.$refs.form.validateField('cover');
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
    }
    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
    .main-container {
        width: 810px;
        margin: 10px auto;
    }
    .upload-hint {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        line-height: 146px;
        vertical-align: top;
        &:hover, &:focus {
            border-color: #409EFF;
            color: #409EFF;
        }
        font-size: 28px;
        color: #8c939d;
    }
    .logo-image {
        @include wh(317px, 175px);
        @include cover-bg;
    }
</style>



// WEBPACK FOOTER //
// src/views/kindergarten/notice/NoticeEdit.vue